import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";

@autoinject
export class AssignmentService {

    constructor(private requestClient: RequestClientService) {
    }

    public get(entityId: number, entityTypeId: number): Promise<any> {
        return this.requestClient.get<any>("Assignment", { entityId, entityTypeId });
    }

    public save(entityId: number, entityType: number, assignedTo: number, assignmentComment: string, previouslyAssignedTo?: number): Promise<any> {
        return this.requestClient.post<any>("Assignment", {}, { assignedTo, assignmentComment, entityType, entityId, previouslyAssignedTo });
    }

}
